export const isMobileApp = () => {
  if (localStorage.appDevice) {
    const device = localStorage.appDevice;
    if (device === 'ios' || device === 'android') {
      return true;
    }
  }
};

export const isAndroidApp = () => {
  if (localStorage.appDevice) {
    const device = localStorage.appDevice;
    if (device === 'android') {
      return true;
    }
  }
  return false;
};
